<template>
    <div>
        <v-switch
            v-model="permissions.show_exclude"
            :label="'Escludi questi ruoli dalla visualizzazione di questa azione: ' + (permissions.show_exclude ? 'Si' : 'No')"
            inset
            hide-details
            class="mb-2 ma-0"
            @change="normalize"
        ></v-switch>
        <v-select
            v-model="permissions.show"
            :items="roleItemsWithAll(roles)"
            label="Permessi Visibilità"
            multiple
            dense
            chips
            small-chips
            :menu-props="{'offset-y': true}"
            outlined
            hide-details
            @change="normalize"
        ></v-select>
        <p class="text-caption grey--text mt-2 mb-0">
            Nascondere un'azione non ne vieta l'uso: per impedire l'operazione a un ruolo usa i permessi in Impostazioni → Ruoli.
        </p>
    </div>
</template>

<script>
import FieldRolePermissionsMixin from '@/mixins/FieldRolePermissionsMixin'

// Stessa forma dei permessi colonna di FieldsTableSelector: il backend li
// valuta con la stessa regola (BaseModelTrait::isActionAllowedForRole)
export function defaultActionPermissions() {
    return {
        show: ['*'],
        show_exclude: false
    }
}

export default {
    name: 'ActionRolePermissions',

    mixins: [FieldRolePermissionsMixin],

    props: {
        // Oggetto della voce di config, modificato sul posto come in FieldsTableSelector
        permissions: {
            type: Object,
            required: true
        },
        roles: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        // Come nei campi: "Tutti i ruoli" e i singoli ruoli si escludono a vicenda,
        // lista vuota senza esclusione = tutti
        normalize() {
            Object.assign(this.permissions, this.normalizeRolePermissions(this.permissions))
        }
    }
}
</script>
